import { TOP_MENU_API_BASE, V2_CLIENT_CODE_KEY } from '../Constants/APIConstantsV2';

const getMenuTree = (location, showFullMenu) => {
    let url = new URL(`${TOP_MENU_API_BASE}${location}/menus/tree`);
    url.searchParams.append("includedItems", showFullMenu);
    return fetch(url, {

            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-functions-key': V2_CLIENT_CODE_KEY
            }
    });
}

export default getMenuTree;